module.exports = __webpack_public_path__ + "static/media/arrow-down.7249abb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.svg
// module id = 151
// module chunks = 0